import React from "react";
import { Text, View } from "react-native";

import appStyles from "../../../appStyles";
import styles from "./integrationStyles";
import { pluralize } from "../../../../helpers/utils";
import IntegrationDateTime from "./IntegrationDateTime";

export default function CalendarIntegration(props) {
  const { data } = props;
  const source = data?.source || {};
  const attendeesCount = data.attendees ? data.attendees.length : 0;
  const mediaText = data.eventName || data.name; // using name for Rules page -> Delete rule dialog

  return (
    <View>
      <Text style={styles.integrationName} numberOfLines={1} title={mediaText}>
        {mediaText}
      </Text>

      <View
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {data.calendarName ? (
          <Text
            numberOfLines={1}
            style={[appStyles.captionThin, { maxWidth: "40%" }]}
          >
            {data.calendarName}
          </Text>
        ) : null}
        {attendeesCount > 0 ? (
          <Text style={appStyles.captionThin}>
            {" "}
            • {pluralize("Attendee", attendeesCount)}
          </Text>
        ) : null}

        <IntegrationDateTime
          {...props}
          source={source}
          hasSourceInfo={data.calendarName || attendeesCount}
        />
      </View>
    </View>
  );
}
